import { useSyncExternalStore } from 'react';

// 768px corresponds to @custom-media --view-md in media.css
const MEDIA_QUERY = '(min-width: 768px)';

/**
 * Responsive hook that updates when screen width crosses the 768px breakpoint
 */
export function useIsMobile() {
  const subscribe = (callback: () => void) => {
    const mediaQuery = window.matchMedia(MEDIA_QUERY);
    mediaQuery.addEventListener('change', callback);
    return () => mediaQuery.removeEventListener('change', callback);
  };

  const getSnapshot = () => !window.matchMedia(MEDIA_QUERY).matches;

  const getServerSnapshot = () => false;

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
